import { useCustomQuery } from "utilities/hookutils";

type Config = {
  keepPreviousData: boolean;
}

export const templateQueryKey = "messageTemplates";
export const useTemplatesQuery = (
  instruction: server.dto.PaginatedMessageTemplateInstruction,
  config: Config = { keepPreviousData: false }
) => {
  const templatesQuery = useCustomQuery({
    queryFn: async () => window.CoreApi.MessageTemplate.Paginated(instruction),
    queryKey: [templateQueryKey, instruction],
    keepPreviousData: config.keepPreviousData
  });

  return templatesQuery;
};

export const getInvitationTranslation = async (templateId: number, language: server.dto.Languages) => {
  const translations = await window.CoreApi.MessageTemplate.ListInvitationTranslation(templateId);
  return translations.data.data.find(t => t.language === language);
}

export const getInvoiceTemplateTranslation = async (templateId: number, language: server.dto.Languages) => {
  const translations = await window.CoreApi.MessageTemplate.ListInvoiceDocumentTranslation(templateId);
  return translations.data.data.find(t => t.language === language);
}